import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class CreateOrVisitSuggestionsList extends Vue {
  @Prop() private identifier!: string;

  @Emit('click')
  public click() {}
}
